<template>
    <ds-modal
        data-qa="sms-broadcast-compliance-modal"
        :is-open="isOpen"
        @close="close"
    >
        <div>
            <ds-icon-button name="x" @click="close" />
            <section class="modal-intro">
                <p class="title">
                    {{ $options.MESSAGE_CONSTANTS.title }}
                </p>

                <p class="description">
                    {{ $options.MESSAGE_CONSTANTS.pleaseReview }}
                </p>

                <ds-illustration class="completed-tasks-color" name="completed-tasks-color" />
            </section>
        </div>

        <section class="resources">
            <p>
                {{ $options.MESSAGE_CONSTANTS.reviewMessage }}
            </p>

            <ul class="link-list">
                <li>
                    <a :href="complianceLink" rel="noopener noreferer" target="_blank">
                        {{ $options.MESSAGE_CONSTANTS.complianceLink }}

                        <ds-icon name="external-link" />
                    </a>
                </li>
                <li>
                    <a :href="bestPracticesLink" rel="noopener noreferer" target="_blank">
                        {{ $options.MESSAGE_CONSTANTS.bestPracticesLink }}

                        <ds-icon name="external-link" />
                    </a>
                </li>
                <li>
                    <a :href="tcpaLink" rel="noopener noreferer" target="_blank">
                        {{ $options.MESSAGE_CONSTANTS.tcpaLink }}

                        <ds-icon name="external-link" />
                    </a>
                </li>
            </ul>
        </section>

        <div class="actions">
            <ds-text-button data-qa="back-button" @click="close">
                {{ $options.MESSAGE_CONSTANTS.back }}
            </ds-text-button>

            <ds-filled-button
                data-qa="send-button"
                @click="markTutorialCompleteAndSend"
            >
                {{ $options.MESSAGE_CONSTANTS.send }}
            </ds-filled-button>
        </div>
    </ds-modal>
</template>


<script>
export const MESSAGE_CONSTANTS = {
    title: 'Protect Yourself',
    pleaseReview: 'Please review this important information',
    reviewMessage: 'Before you send, please review the resources below, including the Telephone Consumer Protection Act and carrier rules. These resources cover permissions, appropriate times to send, opt-in rules, and more.',
    back: 'Back',
    send: 'I understand, send broadcast',
    complianceLink: 'Guide to U.S. SMS Compliance (Twilio)',
    bestPracticesLink: 'Messaging Principles & Best Practices (Cellular Telecommunications Industry Association)',
    tcpaLink: 'Telephone Consumer Protection Act (TCPA)',
};

export default {
    MESSAGE_CONSTANTS,

    props: {
        isOpen: Boolean,
    },

    data() {
        return {
            complianceLink: 'https://www.twilio.com/learn/call-and-text-marketing/guide-to-us-sms-compliance',
            bestPracticesLink: 'https://www.ctia.org/the-wireless-industry/industry-commitments/messaging-interoperability-sms-mms',
            tcpaLink: 'https://www.fdic.gov/regulations/compliance/manual/8/viii-5.1.pdf',
        };
    },

    methods: {
        close() {
            this.$emit('close');
        },

        markTutorialCompleteAndSend() {
            this.$emit('send');
        },
    },
};
</script>

<style lang="scss" scoped>
    .title {
        font-size: $font-size-mega;
        line-height: 3rem;
    }

    .description {
        font-size: $font-size-xl;
    }

    .modal-intro {
        font-family: $font-family-secondary-title;
        font-weight: $font-weight-bold;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin-bottom: $spacing-100;
    }

    .resources {
        display: flex;
        flex-direction: column;
    }

    .link-list {
        @include padding-start($spacing-200);
        list-style: disc outside;
        --icon-size: #{px-to-rem(13.33px)};
    }

    .actions {
        padding-top: $spacing-400;
    }
</style>
